import { useState, useRef, useEffect } from 'react';

export const useSearch = () => {
  const [search, setSearch] = useState('');
  const timer = useRef(null);

  const debounce = (fn) => {
    return (value) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        fn(value);
      }, 300);
    };
  };

  const debouncedSearch = debounce((value) => setSearch(value));

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  return { search, debouncedSearch };
};
